module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm-5 24H7a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1zm0-6H7a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1zm0-6H7a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/menu-1.js
// module id = 1268
// module chunks = 14